import { getTravellerName } from '../../../../../../utils';
export const isOnlyAirportCheckinStatus = (status) => /^OnlyAirportCheckIn$/i.test(status);
export const hasSegmentBoardingPass = (segment, segmentsFailedBoardingPasses) => segment.checkinInfo.airportHasDcs &&
    segment.checkinInfo.hasBoardingPasses !== false &&
    !segmentsFailedBoardingPasses.has(segment.id);
export const isDifferentCurrenciesError = (error) => {
    var _a;
    const differentCurrenciesError = 'The check in order cannot be processed because one of the tickets is issued in a currency different from the currency of the pass tickets in the check order';
    return (error.message.includes(differentCurrenciesError) ||
        ((_a = error.debugMessage) === null || _a === void 0 ? void 0 : _a.includes(differentCurrenciesError)));
};
export const getOnlyAirportCheckinTravellersNames = (segments, travellers, selectedSegments) => {
    const selectedCheckinSegments = segments.length > 1 ? segments.filter(segment => selectedSegments.has(segment.id)) : segments;
    const onlyAirportCheckinTravellerIds = new Set();
    selectedCheckinSegments.forEach(segment => {
        segment.checkinInfo.travellersData.travellers.forEach(traveller => {
            if (isOnlyAirportCheckinStatus(traveller.subStatus)) {
                onlyAirportCheckinTravellerIds.add(traveller.traveller.id);
            }
        });
    });
    return travellers
        .filter(traveller => onlyAirportCheckinTravellerIds.has(traveller.id))
        .map(traveller => getTravellerName(traveller, undefined));
};
export const getOnlyAirportCheckinFlights = (segments, selectedSegments) => {
    return segments
        .map(segment => {
        if (selectedSegments.has(segment.id) && isOnlyAirportCheckinStatus(segment.checkinInfo.checkInSubStatus)) {
            return `${segment.departure.airport.iata} - ${segment.arrival.airport.iata}`;
        }
        return null;
    })
        .filter(Boolean);
};
